import type { PluginSidebar, PluginSidebarProps } from "@d12labs/plugins/types";
import { BrandSquare, SidebarBrand, SidebarNavItem, SidebarSection } from "@d12labs/ui/sidebar-kit";
import { ClipboardList, Home, Mic, ScrollText } from "lucide-react";

export const pluginSidebar: PluginSidebar = ({ onBack, onNavigate }: PluginSidebarProps) => {
	return (
		<div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
			<SidebarBrand
				icon={<BrandSquare icon={Mic} />}
				title="Speech Coach"
				subtitle="Practice & improve"
				onBack={onBack}
			/>
			<div className="flex flex-col gap-1 px-2 py-2">
				<SidebarSection>
					<SidebarNavItem
						to="/speech-coach"
						exact
						icon={Home}
						label="Today"
						onNavigate={onNavigate}
					/>
					<SidebarNavItem
						to="/speech-coach/plan"
						icon={ClipboardList}
						label="Plan"
						onNavigate={onNavigate}
					/>
					<SidebarNavItem
						to="/speech-coach/practice"
						icon={Mic}
						label="Practice"
						onNavigate={onNavigate}
					/>
					<SidebarNavItem
						to="/speech-coach/history"
						icon={ScrollText}
						label="History"
						onNavigate={onNavigate}
					/>
				</SidebarSection>
			</div>
		</div>
	);
};
